module.exports = __webpack_public_path__ + "img/fstlogo.ad925220.png";